import React, { useEffect, useState } from "react";
import "./latestcourse.css";
import { apiConstants } from "../constants/apiurl.constant";
import { miscService } from "../service/misc.service";
import { ChevronRight, Loader2 } from "lucide-react";

export const LatestCourse = () => {
  const [courseData, setCourseData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getLatestCourse();
  }, []);

  const getLatestCourse = async () => {
    try {
      setIsLoading(true);
      const response = await miscService.getLatestCourses();

      if (response.data) {
        setCourseData([...response.data.rows, { id: 0, name: "Show More" }]);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  // Course Skeleton Component
  const CourseSkeleton = () => (
    <div className="courseitem skeleton">
      <div className="skeleton-course-img"></div>
      <div className="course-data">
        <div className="skeleton-course-name"></div>
        <div className="course-info">
          <div className="course-details mt-2">
            <div className="skeleton-detail-item">
              <div className="skeleton-icon"></div>
              <div className="skeleton-text"></div>
              <div className="skeleton-label"></div>
            </div>
            <div className="skeleton-detail-item">
              <div className="skeleton-icon"></div>
              <div className="skeleton-text"></div>
              <div className="skeleton-label"></div>
            </div>
          </div>
          <div className="course-question">
            <div className="skeleton-detail-item">
              <div className="skeleton-icon"></div>
              <div className="skeleton-text"></div>
              <div className="skeleton-label"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // Explore Button Skeleton
  const ExploreSkeleton = () => (
    <div className="courseitem exploreitem skeleton">
      <div className="skeleton-explore-content">
        <div className="skeleton-explore-text"></div>
        <div className="skeleton-explore-icon"></div>
      </div>
    </div>
  );

  // Generate skeleton items (typically 6-8 course cards + 1 explore button)
  const generateSkeletons = (count = 7) => {
    const skeletons = [];
    
    // Add course skeletons
    for (let i = 0; i < count - 1; i++) {
      skeletons.push(<CourseSkeleton key={`course-skeleton-${i}`} />);
    }
    
    // Add explore skeleton
    skeletons.push(<ExploreSkeleton key="explore-skeleton" />);
    
    return skeletons;
  };

  // Empty State Component
  const EmptyState = () => (
    <div className="courses-empty-state">
      <div className="empty-state-content">
        <div className="empty-state-icon">🎓</div>
        <p className="empty-state-message">
          No courses available at the moment.
        </p>
        <button 
          className="retry-btn"
          onClick={getLatestCourse}
        >
          Try Again
        </button>
      </div>
    </div>
  );

  return (
    <div className="container" id="courselist">
      <div className="header-container">
        <div className="head-txt">
          Latest Courses
          {isLoading && (
            <Loader2 className="course-loading-spinner" size={20} />
          )}
        </div>
        <div className="head-desc">
          Dive into our extensive collection of MCQs, meticulously crafted to
          reinforce your understanding of key concepts.
        </div>
      </div>

      <div className="course-container">
        {isLoading ? (
          // Show skeleton loading
          generateSkeletons()
        ) : !courseData || courseData.length === 0 ? (
          // Show empty state
          <EmptyState />
        ) : (
          // Show actual content
          courseData?.map((course, index) => (
            <div key={course?.id || index}>
              {course?.id !== 0 ? (
                <div data-aos="zoom-in" className="courseitem">
                  <img
                    src={
                      course?.image
                        ? apiConstants.imgUrl + course?.image
                        : 'https://i.postimg.cc/9f6rgsyX/course-dummy.png'
                    }
                    className="course_img"
                    alt="Course-Image"
                    onError={(e) => {
                      e.target.src = 'https://i.postimg.cc/9f6rgsyX/course-dummy.png';
                    }}
                  />
                  <div className="course-data">
                    <div className="course_name">
                      {course?.course_name || "Untitled Course"}
                    </div>
                    <div className="course-info">
                      <div className="course-details mt-2">
                        <div className="">
                          <img
                            src="/assets/img/book.png"
                            alt="book-icon"
                            className="course-details-icon"
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                          {course.total_subjects || 0} <span>Chapters</span>{"  "}
                        </div>
                        <div className="">
                          <img
                            src="/assets/img/subject.png"
                            alt="book-icon"
                            className="course-details-icon"
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                          {course.total_topics || 0} <span>Topics</span>
                        </div>
                      </div>
                      <div className="course-question">
                        <img
                          src="/assets/img/question.png"
                          alt="book-icon"
                          className="course-details-icon"
                          onError={(e) => {
                            e.target.style.display = 'none';
                          }}
                        />
                        {course.total_questions || 0} <span>Questions</span>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div 
                  onClick={() => window.location.href = "https://app.edraakonline.com/login"} 
                  className="courseitem exploreitem"
                >
                  <div>
                    <span>Explore All Courses</span>
                    <ChevronRight size={18} />
                  </div>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};